var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUserCircleLg = function SvgIconUserCircleLg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.059,
    height: 132.059,
    viewBox: "0 0 132.059 132.059",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.029.563a66.029,66.029,0,1,0,66.029,66.029A66.018,66.018,0,0,0,66.029.563Zm0,25.56A23.43,23.43,0,1,1,42.6,49.552,23.43,23.43,0,0,1,66.029,26.122Zm0,91.589A51.02,51.02,0,0,1,27.024,99.553,29.685,29.685,0,0,1,53.249,83.632a6.515,6.515,0,0,1,1.89.293,35.251,35.251,0,0,0,10.89,1.837,35.118,35.118,0,0,0,10.89-1.837,6.514,6.514,0,0,1,1.89-.293,29.685,29.685,0,0,1,26.225,15.922A51.02,51.02,0,0,1,66.029,117.711Z",
    transform: "translate(0 -0.563)",
    fill: "#8d8585"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUserCircleLg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-user-circle-lg.efabb83e.svg";
export { ForwardRef as ReactComponent };